import { useQuery } from 'react-query'
import {
  getDetailedMapResult,
  getLookupDisplayValue,
  getLookupResult,
  getSearchConfig,
  getSearchResult,
  searchAddress,
  SearchQuery,
} from '../../../generic-search-common/src'
import { RequestOptions } from '@msaf/generic-search-common'

export function useGetSearchConfig(searchTypeKey: string, options?: RequestOptions, isEnableQuery: boolean = true) {
  return useQuery(['searchConfig', searchTypeKey, options?.urlPrefix], () => getSearchConfig(searchTypeKey, options), {
    refetchOnWindowFocus: false,
    enabled: isEnableQuery,
  })
}

export function useGetSearchResult(searchQuery?: SearchQuery, options?: RequestOptions, isEnableQuery: boolean = true) {
  return useQuery(['searchResult', searchQuery, options?.urlPrefix], () => getSearchResult(searchQuery, options), {
    refetchOnWindowFocus: false,
    enabled: isEnableQuery,
  })
}

export function useGetLookupResult(lookupQuery: Record<string, string | undefined>, options?: RequestOptions) {
  return useQuery(['lookupResult', lookupQuery, options?.urlPrefix], () => getLookupResult(lookupQuery, options), {
    refetchOnWindowFocus: false,
    // Wait for 200ms before marking the data as stale.
    // This prevents from triggering multiple lookup requests while other parts of the page state is still loading.
    staleTime: 200,
  })
}

export function useGetLookupDisplayValue(
  lookupDisplayValueQuery: Record<string, string | undefined>,
  options?: RequestOptions,
  isEnableQuery: boolean = true,
) {
  return useQuery(
    ['lookupDisplayValue', lookupDisplayValueQuery, options?.urlPrefix],
    () => getLookupDisplayValue(lookupDisplayValueQuery, options),
    {
      refetchOnWindowFocus: false,
      enabled: isEnableQuery,
    },
  )
}

export function useSearchAddress(query: string, options?: RequestOptions) {
  return useQuery(['searchAddress', query, options?.urlPrefix], () => searchAddress(query, options), {
    refetchOnWindowFocus: false,
  })
}

export function useGetDetailedMapResult(
  searchTypeKey: string,
  identifier: string | number | boolean | null,
  options?: RequestOptions,
  isEnableQuery: boolean = true,
) {
  return useQuery(
    ['detailedMapResult', searchTypeKey, identifier, options?.urlPrefix],
    () => getDetailedMapResult(searchTypeKey, identifier, options),
    {
      refetchOnWindowFocus: false,
      enabled: isEnableQuery,
    },
  )
}
